import { Component, inject, input, OnInit, output, viewChild } from "@angular/core";
import { ChatbotChildContainer } from "chatbot/chatbot.component";
import { ChatbotHistoryComponent } from "chatbot/menu/history/chatbot-history.component";
import { ButtonComponent } from "common/buttons/button.component";
import { TabsComponent } from "common/tab/tabs.component";
import { TabNoRouteComponent } from "common/tab/tab-no-route.component";
import { MenuComponent } from "common/menu/menu.component";
import { AsyncPipe, NgClass } from "@angular/common";
import { ChatbotSettingsComponent } from "chatbot/menu/settings/chatbot-settings.component";
import { TranslateModule } from "@ngx-translate/core";
import { ChatbotResource } from "core/stages-client";

@Component({
	selector: "stages-chatbot-menu",
	templateUrl: "./chatbot-menu.component.html",
	styleUrls: ["./chatbot-menu.component.scss"],
	imports: [
		ButtonComponent,
		TabsComponent,
		TabNoRouteComponent,
		MenuComponent,
		NgClass,
		ChatbotHistoryComponent,
		ChatbotSettingsComponent,
		TranslateModule,
		AsyncPipe,
	],
})
export class ChatbotMenuComponent implements OnInit {
	readonly currentChatGuid = input<string>();

	private chatbotResource = inject(ChatbotResource);
	protected activeContainer: ChatbotChildContainer = ChatbotChildContainer.HISTORY;
	protected settingsOpen: boolean = true;
	protected settings$!: Promise<stages.chatbot.Settings>;

	historyMenuItems: MenuItem[] = [];

	readonly closeButtonPressed = output<void>();

	readonly triggerReload = output<void>();

	readonly triggerReset = output<void>();

	readonly chatbotHistory = viewChild.required(ChatbotHistoryComponent);

	ngOnInit(): void {
		this.settings$ = this.chatbotResource.getSettings();

		this.historyMenuItems = [
			{
				name: "chatbot.history.delete.chats",
				iconClass: "ico ico-delete",
				on: () => {
					const chatbotHistory = this.chatbotHistory();
					if (chatbotHistory) {
						chatbotHistory.multiDelete();
					}
				},
			},
		];
	}

	openChildContainer(showContainer: ChatbotChildContainer, hideContainer: ChatbotChildContainer): void {
		if (showContainer === ChatbotChildContainer.HISTORY) {
			const chatbotElement = document.getElementById(showContainer);
			const settingsElement = document.getElementById(hideContainer);
			if (chatbotElement && settingsElement) {
				chatbotElement.style.transform = "translateX(0%)";
				settingsElement.style.transform = "translateX(0%)";

				const onTransitionEnd = (): void => {
					this.settingsOpen = false;
					chatbotElement.removeEventListener("transitionend", onTransitionEnd);
				};
				chatbotElement.addEventListener("transitionend", onTransitionEnd);
			}
		} else {
			if (showContainer === ChatbotChildContainer.SETTINGS) {
				this.settingsOpen = true;
			}

			setTimeout(() => {
				const chatbotElement = document.getElementById(hideContainer);
				const settingsElement = document.getElementById(showContainer);

				if (chatbotElement && settingsElement) {
					chatbotElement.style.transform = "translateX(-100%)";
					settingsElement.style.transform = "translateX(-100%)";
				}
			}, 100);
		}
		this.activeContainer = showContainer;
	}

	reloadChatbot(): void {
		// TODO: The 'emit' function requires a mandatory void argument
		this.triggerReload.emit();
		// TODO: The 'emit' function requires a mandatory void argument
		this.closeButtonPressed.emit();
	}

	onChatsDeleted(chatGuids: string[]): void {
		if (!!this.currentChatGuid() && chatGuids.indexOf(this.currentChatGuid()!) >= 0) {
			this.triggerReset.emit();
		}
	}

	protected readonly ChatbotChildContainer = ChatbotChildContainer;
}
